import { PROCEDURE_IDS } from '@zocdoc-frontend-common/utils-constants';

export const BOOKING_CONTAINER_ROOT_KEY = 'bookingContainer';
export const SIGN_IN_FORM_ROOT_KEY = 'signInForm';
export const CREATE_ACCOUNT_FORM_ROOT_KEY = 'createAccountForm';
export const NEW_SUBPATIENT_FORM_ROOT_KEY = 'newSubpatientForm';
export const PHONE_VERIFICATION_ROOT_KEY = 'phoneVerificationPage';
export const APPOINTMENT_INFO_ROOT_KEY = 'appointmentInfoPage';
export const APPOINTMENT_DETAILS_ROOT_KEY = 'appointmentDetailsPage';
export const APPOINTMENT_REQUIREMENTS_ROOT_KEY = 'appointmentRequirements';
export const PHONE_ENTRY_ROOT_KEY = 'phoneEntryPage';
export const PATIENT_ROOT_KEY = 'patient';
export const SCHEDULING_ROOT_KEY = 'scheduling';
export const PROCEDURE_ROOT_KEY = 'procedureDropdown';
export const PHONE_ROOT_KEY = 'phone';
export const DOCTOR_CARD_ROOT_KEY = 'doctorCard';
export const INITIAL_BOOKING_ROOT_KEY = 'bookingInit';
export const PATIENT_INSURANCE_KEY = 'insurance';
export const REVIEW_AND_BOOK_ROOT_KEY = 'reviewAndBook';
export const WELL_GUIDE_ROOT_KEY = 'wellGuide';
export const SIGN_UP_KEY = 'signUp';
export const SURVEY_ROOT_KEY = 'survey';
export const RESET_PASSWORD_ROOT_KEY = 'resetPassword';
export const USER_ROOT_KEY = 'user';
export const REVIEW_AND_BOOK_SCAN_INSURANCE_CARD_ROOT_KEY =
    'reviewAndBookScanInsuranceCard';

export const pageName = 'Booking';

export const BookingStateProperties = {
    bookingId: 'id',
    appointmentTime: 'appointment_time',
    providerCloudId: 'provider_cloud_id',
    providerId: 'provider_id',
    existingPatient: 'existing_patient',
    procedureId: 'visit_reason',
    locationCloudId: 'location_cloud_id',
    locationId: 'location_id',
    insuranceCarrierId: 'insurance_carrier_id',
    insurancePlanId: 'insurance_plan_id',
    patientId: 'patient_id',
    requirements: 'requirements',
    status: 'status',
    referralId: 'referral_id',
    insuranceCardDataId: 'insurance_card_data_id',
    isInsuranceCardShared: 'is_insurance_card_shared',
    iceRequestToken: 'ice_request_token',
    rescheduleRequestId: 'reschedule_request_id',
    hasBookedProviderBefore: 'has_booked_provider_before',
    appointmentInstructions: 'appointment_instructions',
};

export const MEMBER_ID_SOURCE_TYPE = {
    PATIENT_INPUT: 'patient_input',
    INSURANCE_API: 'insurance_api',
};
export const BOOKING_STATUS = {
    IN_PROGRESS: 'in_progress',
    PENDING: 'pending',
    COMPLETE: 'complete',
    FAILED: 'failed',
};

export const ERROR_CODES = {
    AVAILABLE_TIME_SLOT: 'AvailableTimeSlot',
    GOVERNMENT_INSURANCE_ERROR: 'GovernmentInsurance',
};

export const HttpStatusCodes = {
    OK: 200,
    Created: 201,
    BadRequest: 400,
    Unauthorized: 401,
    Forbidden: 403,
    NotFound: 404,
    UnprocessableEntity: 422,
};

export const PATIENT_INSURANCE_TYPES = {
    HEALTH: 'health',
    DENTAL: 'dental',
};

export const DENTAL_INSURANCE_SPECIALTIES = new Set([
    '333', // SPECIALTY_IDS.COSMETIC_DENTIST,
    '334', // SPECIALTY_IDS.DENTAL_PAIN_SPECIALIST,
    '98', // SPECIALTY_IDS.DENTIST,
    '134', // SPECIALTY_IDS.ENDODONTIST,
    '151', // SPECIALTY_IDS.ORAL_SURGEON,
    '135', // SPECIALTY_IDS.ORTHODONTIST,
    '152', // SPECIALTY_IDS.PEDIATRIC_DENTIST,
    '136', // SPECIALTY_IDS.PERIODONTIST,
    '137', // SPECIALTY_IDS.PROSTHODONTIST,
]);

export const TRACKING_CONSTANTS = {
    ProviderCard: 'ProviderCard',
    AppointmentDate: 'AppointmentDate',
    Name: 'Name',
    Photo: 'Photo',
    Location: 'Location',
    Specialty: 'Specialty',
    Ratings: 'Ratings',
    PatientName: 'PatientName',
    VisitReason: 'VisitReason',
};

export const COVID_VACCINE_PROCEDURE_IDS = [
    PROCEDURE_IDS.COVID_19_VACCINE_DOSE_1,
    PROCEDURE_IDS.COVID_19_VACCINE_DOSE_2,
    PROCEDURE_IDS.COVID_19_VACCINE_BOOSTER_MODERNA_PFIZER,
    PROCEDURE_IDS.COVID_19_VACCINE_BOOSTER_JOHNSON_JOHNSON,
];

export const AccountType = {
    Default: 'default',
    Google: 'google',
    Facebook: 'facebook',
    Apple: 'apple',
};
